import React from 'react';
import {connect} from 'react-redux'
import Picker from './Picker';
import {colorpickerColorChanged} from '../../actions/recoloring';
import {singleColorChanged} from "../../actions/recoloring";

const MyColorPicker = ( props ) => {
    return <Picker color={props.color}
                        onChange={props.onChange}
                        onChangeComplete={props.onChangeComplete}
                       />;
};

const mapDispatch = ( dispatch ) => {

    return ({
        onChangeComplete: ( color ) => dispatch( singleColorChanged( color ) ),
        onChange: ( color ) => dispatch( colorpickerColorChanged( color ) )
    })
};

const mapState = ( state, ownProps ) => {
    return {
        color      : state.stolo.colorpicker.color,
    }
};

export default connect( mapState, mapDispatch )( MyColorPicker );



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorPicker.js